import React from 'react';
import EmptySpace from './EmptySpace';
import { templateHelper } from '../../../template/helpers/templateHelper';

export const emptySpaceHandler = {
    tags,
    elementEditor,
    defaultStyle,
    component,
    families
}

function component(element) {
    return <EmptySpace element={element} />
}

function tags() {
    return {
        startTag: '<!-- Clear Spacer : BEGIN -->',
        endTag: '<!-- Clear Spacer : END -->'
    }
}

function families(){
    return [
        'space'
    ]
}

function defaultStyle(templateStyle, defaultStyle) {
    const templateBackgroundStyle = templateStyle ? templateStyle.main : null;
    return {
        styleProps: {
            height: '40px',
            backgroundColor: templateBackgroundStyle && !defaultStyle ? templateBackgroundStyle.background : '#fff'
        },
    }
}
function elementEditor(elementStyle, templateStyle = null, defaultStyle = true) {
    //Take what is relevant from the template
    const templateBackgroundStyle = templateStyle ? templateStyle.main : null;
    return (
        `<tr>
            <td aria-hidden="true" height="${parseInt(elementStyle.styleProps.height)}" style="font-size: 0px; line-height: 0px;
             background: ${templateBackgroundStyle && !defaultStyle ? templateHelper.convertRgbStringToHex(templateBackgroundStyle.background) : 
                templateHelper.convertRgbStringToHex(elementStyle.styleProps.backgroundColor)}; width: 680px; height:${elementStyle.styleProps.height}px;">
                &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;
            </td>
        </tr>`
    )
};

/* 
<td aria-hidden="true" height="40" style="font-size: 0px; line-height: 0px;">
                        &nbsp;
                    </td>
 */

